// Gerekli importları ekleyelim
import { StyleManager } from './StyleManager.js';
import { ThemeProvider } from '../themes/ThemeProvider.js';
import { Router } from '../router/Router.js';
import { PageBuilder } from './PageBuilder.js';

export class Application {
    constructor(config = {}) {
        try {
            // Config kontrolü
            this.config = {
                theme: 'light',
                ...config
            };

            // Önce StyleManager'ı başlat
            this.styleManager = new StyleManager();

            // Sonra ThemeProvider'ı başlat
            this.themeProvider = new ThemeProvider(this.config.theme);

            // Diğer servisleri başlat
            this.pageBuilder = new PageBuilder();
            this.router = new Router({
                pageBuilder: this.pageBuilder
            });

            // Global stilleri ekle
            this.initializeStyles();
            
            // Tema ayarlarını uygula
            this.initialize(this.config);
        } catch (error) {
            console.error('Application başlatma hatası:', error);
            throw error; // Hatayı yukarı fırlat
        }
    }

    initializeStyles() {
        try {
            // Global stilleri ekle
            this.styleManager.addStyles({
                '*': {
                    boxSizing: 'border-box',
                    margin: 0,
                    padding: 0
                },
                'body': {
                    fontFamily: 'var(--typography-fontFamily)',
                    fontSize: 'var(--typography-fontSize-md)',
                    lineHeight: 'var(--typography-lineHeight-normal)',
                    color: 'var(--text-primary)',
                    background: 'var(--background)'
                },
                '.opt-app': {
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column'
                }
            });
        } catch (error) {
            console.error('Stil başlatma hatası:', error);
        }
    }

    initialize(config) {
        try {
            // Tema özelleştirmelerini uygula
            if (config.themeCustomizations) {
                Object.entries(config.themeCustomizations).forEach(([theme, customizations]) => {
                    this.themeProvider.customizeTheme(theme, customizations);
                });
            }
        } catch (error) {
            console.error('Theme özelleştirme hatası:', error);
        }
    }

    async mount(container) {
        try {
            if (!container) {
                throw new Error('Container element gerekli');
            }

            // ThemeProvider kontrolü
            const currentTheme = this.themeProvider?.getCurrentTheme() || 'light';

            const appContainer = document.createElement('div');
            appContainer.className = `opt-app theme-${currentTheme}`;
            
            const mainContent = document.createElement('main');
            mainContent.className = 'opt-main-content';
            appContainer.appendChild(mainContent);

            container.innerHTML = '';
            container.appendChild(appContainer);

            if (this.router) {
                this.router.setContainer(mainContent);
                await this.router.handleRoute();
            }
        } catch (error) {
            console.error('Application mount hatası:', error);
            // Fallback olarak basit bir container oluştur
            container.innerHTML = '<div class="opt-app"><main class="opt-main-content"></main></div>';
        }
    }
}